import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Minus, Plus, X } from "lucide-react";

function rupee(n) { return `₹${Number(n).toLocaleString("en-IN")}`; }

export default function Cart() {
  const { items, subtotal, updateItem, removeItem, count } = useCart();
  // Free shipping over ₹5,000; flat ₹200 otherwise; nothing when cart is empty.
  let shipping = 0;
  if (subtotal > 0 && subtotal < 5000) shipping = 200;
  const total = subtotal + shipping;

  return (
    <div className="px-6 md:px-12 lg:px-24 py-16 min-h-[70vh]" data-testid="cart-page">
      <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Your Edit</div>
      <h1 className="font-serif-h font-light text-5xl text-stone-900">Shopping Bag</h1>
      <div className="text-sm text-stone-500 mt-2">{count} {count === 1 ? "piece" : "pieces"}</div>

      {items.length === 0 ? (
        <div className="mt-16 text-center py-16 border border-warm">
          <div className="font-serif-h text-2xl text-stone-800">Your bag is empty</div>
          <p className="text-stone-500 mt-2 text-sm">Begin your Riddhi edit with a handloom heirloom.</p>
          <Link to="/shop/sarees" className="btn-ink mt-8 inline-flex" data-testid="cart-shop-link">Continue Shopping</Link>
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-6">
            {items.map((it) => (
              <div key={`${it.product_id}-${it.size}`} className="flex gap-5 border-b border-warm pb-6" data-testid={`cart-item-${it.product_id}`}>
                <Link to={`/product/${it.product_id}`} className="w-24 md:w-32 flex-shrink-0">
                  <img src={it.product?.images?.[0]} alt="" className="w-full aspect-[3/4] object-cover bg-[#F3EAE8]" />
                </Link>
                <div className="flex-1 flex flex-col">
                  <div className="flex justify-between">
                    <div>
                      <Link to={`/product/${it.product_id}`} className="font-serif-h text-lg md:text-xl text-stone-900">
                        {it.product?.name}
                      </Link>
                      <div className="text-[11px] tracking-overline uppercase text-stone-500 mt-1 capitalize">
                        {it.product?.category} · Size: {it.size}
                      </div>
                    </div>
                    <button onClick={() => removeItem(it.product_id, it.size)} data-testid={`remove-${it.product_id}`} className="p-1">
                      <X size={16} strokeWidth={1.2} />
                    </button>
                  </div>
                  <div className="mt-auto flex items-center justify-between pt-4">
                    <div className="flex items-center border border-warm">
                      <button onClick={() => updateItem(it.product_id, it.size, Math.max(1, it.quantity - 1))} className="w-9 h-10 flex items-center justify-center"><Minus size={12}/></button>
                      <div className="w-8 text-center text-sm">{it.quantity}</div>
                      <button onClick={() => updateItem(it.product_id, it.size, it.quantity + 1)} className="w-9 h-10 flex items-center justify-center"><Plus size={12}/></button>
                    </div>
                    <div className="font-medium">{rupee((it.product?.price || 0) * it.quantity)}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-4">
            <div className="border border-warm p-8 bg-white sticky top-28">
              <div className="font-serif-h text-2xl text-stone-900 mb-6">Order Summary</div>
              <div className="flex justify-between text-sm py-2"><span className="text-stone-600">Subtotal</span><span>{rupee(subtotal)}</span></div>
              <div className="flex justify-between text-sm py-2"><span className="text-stone-600">Shipping</span><span>{shipping === 0 ? "Complimentary" : rupee(shipping)}</span></div>
              {shipping > 0 && <div className="text-xs text-stone-500 mt-1">Add {rupee(5000 - subtotal)} for free shipping</div>}
              <div className="gold-divider my-5" />
              <div className="flex justify-between text-lg"><span>Total</span><span className="font-medium">{rupee(total)}</span></div>
              <Link to="/checkout" className="btn-ink w-full justify-center mt-8" data-testid="checkout-btn">Proceed to Checkout</Link>
              <Link to="/shop/sarees" className="block text-center text-[11px] tracking-overline uppercase text-[#D4AF37] mt-4">Continue Shopping →</Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
